module.exports = __webpack_public_path__ + "@/assets/img/repayment-mobile.d72f2ddf.gif";